export default __webpack_public_path__ + "static/media/Avtar.ae353eab.svg";